/* PEL v1 Fork
 *
 * Create Elements using short hand
 *  https://gist.github.com/lski/7de19ff1b6a460c47190fbed487c5f19
 */
export function el(tagName, attributes = {}, children = []) {
  let ele;

  if (tagName === "svg")
    ele = document.createElementNS("http://www.w3.org/2000/svg", "svg");
  else if (tagName === "path")
    ele = document.createElementNS("http://www.w3.org/2000/svg", "path");
  else {
    ele = document.createElement(tagName);
  }

  //add attributes
  for (var key in attributes) {
    switch (key) {
      case "addEventListener":
        if (attributes["addEventListener"].length === 3) {
          let aE = attributes[key][0];
          let aF = attributes[key][1];
          let aU = attributes[key][2];
          ele.addEventListener(aE, aF, aU);
        }
        break;
      case "addEventListeners":
        if (Array.isArray(attributes["addEventListeners"][0])) {
          attributes["addEventListeners"].forEach((listener) => {
            if (listener.length === 3) {
              let aE = listener[0];
              let aF = listener[1];
              let aU = listener[2];
              ele.addEventListener(aE, aF, aU);
            }
          });
        }
        break;
      case "removeEventListener":
        if (attributes["removeEventListener"].length === 3) {
          let rE = attributes[key][0];
          let rF = attributes[key][1];
          let rU = attributes[key][2];
          ele.removeEventListener(rE, rF, rU);
        }
        break;
      case "data":
        Object.keys(attributes.data).forEach(function (dKey) {
          ele.setAttribute("data-" + dKey, attributes.data[dKey]);
        });
        break;
      case "className":
        ele.setAttribute("class", attributes[key]);
        break;
      case "zIndex":
        ele.setAttribute("z-index", attributes[key]);
        break;
      case "strokeLinecap":
        ele.setAttribute("stroke-linecap", attributes[key]);
        break;
      case "strokeLinejoin":
        ele.setAttribute("stroke-linejoin", attributes[key]);
        break;
      case "selected":
        if (attributes["selected"]) ele.setAttribute("selected", "");
        else ele.removeAttribute("selected");
        break;
      case "checked":
        if (attributes["checked"]) ele.setAttribute("checked", "");
        else ele.removeAttribute("checked");
        break;
      case "disabled":
        if (attributes[key] == true) {
          ele.setAttribute("disabled", "");
        }
        break;
      default:
        ele.setAttribute(key, attributes[key]);
        break;
    }
  }

  if (typeof children === "string") {
    if (containsHTMLTags(children)) {
      ele.appendChild(document.createElement("span")).innerHTML = children;
    } else {
      ele.appendChild(document.createTextNode(children));
    }
  }

  if (Array.isArray(children)) {
    children.forEach(function (child) {
      if (child instanceof Node)
        // || typeof child === 'string')
        ele.appendChild(child);

      if (typeof child === "string" || typeof child === "number")
        ele.appendChild(document.createTextNode(child));
    });
  }

  if (children instanceof Node) ele.appendChild(children);

  return ele;
}

function containsHTMLTags(text) {
  // Updated regex to handle self-closing tags like <br/>, tags with attributes, and valid HTML tags
  const regex = /<([a-zA-Z][^\s/>]*)(\s[^>]*)?(\/?)>/g;
  return regex.test(text);
}
